export default __webpack_public_path__ + "static/840-1c16392385b89e1da825f3413674fb42.gif";